import 'css-chunksrc/client/common/quickAllocationMenu/searchInput/styles.scss';export default {
  "searchInput": "_searchInput_5lxt8_1",
  "input": "_input_5lxt8_12",
  "icon": "_icon_5lxt8_23"
};